//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'project-phone-view',
  props: {
    projectId: {
      type: Number, required: true
    }
  },
  data() {
    const vm = this;
    return {
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      searchInput: {},
      list: [],
      loading: false,
      saving: false,
      columns: [
        {
          type: 'index', width: 60, align: 'center'
        },
        {
          title: '联系类型', key: 'contactTypeStr', align: 'center'
        },
        {
          title: '联系电话', key: 'phoneNumber', align: 'center'
        },
        {
          title: '操作', align: 'center',
          render: (h, params) => {
            const row = params.row;
            const actions = [];

            var del = h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  vm.delContactInfo(params.row);
                }
              }
            }, '删除');

            var edit = h('Button', {
              props: {
                type: 'default',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  vm.editContactInfo(params.row);
                }
              }
            }, '编辑');

            if (vm.hasPermission('Pages.ProjectManage.ProjectPhone.Edit')) {
              actions.push(edit);
            }
            if (vm.hasPermission('Pages.ProjectManage.ProjectPhone.Delete')) {
              actions.push(del);
            }

            return h('div', actions);
          }
        }
      ],
      createPhoneModal: false,
      contactInfo: {id: 0},
      rules: {
        projectName: [{required: true, message: '请选择项目', trigger: 'blur'}],
        phoneNumber: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
        contactType: [{required: true, type: 'number', message: '请选择类型', trigger: 'change'}]
      }
    };
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    }
  },
  methods: {
    getPage() {
      this.loading = true;
      let page = {
        projectId: this.projectId,
        maxResultCount: 100,
        skipCount: (this.currentPage - 1) * this.pageSize
      };
      abp.ajax.post('/api/services/app/Project/SearchContactNumbers', page).then(res => {
        this.list = [];
        this.list.push(...res.data.result.items);
        this.totalCount = res.data.result.totalCount;
      }).finally(() => {
        this.loading = false;
      });
    },
    delContactInfo(row) {
      const vm = this;
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除  ' + row.contactTypeStr + row.phoneNumber + ' 吗？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          abp.ajax.delete('/api/services/app/Project/DeleteContactNumberById?id=' + row.id).then(() => {
            vm.$Notice.success({
              title: '提示',
              desc: '删除成功'
            });
            vm.getPage();
          });
        }
      });
    },
    editContactInfo(row) {
      this.contactInfo = {};
      this.contactInfo = JSON.parse(JSON.stringify(row));
      this.createPhoneModal = true;
    },

    onCancel() {
      this.$refs.contactNumForm.resetFields();
      this.createPhoneModal = false;
    },
    onSave() {
      this.$refs.contactNumForm.validate(async (val) => {
        if (val) {
          this.saving = true;
          abp.ajax.post('/api/services/app/Project/SaveContactNumber', this.contactInfo).then(res => {
            this.loading = false;
            this.createPhoneModal = false;
            this.getPage();
          }).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    }
  },
  created() {
    this.getPage();
  }
};
